import React from 'react';
import {  BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import QrCodeContent from './pages/QrCodes';

const App = () => {
  return (
    <>
      <Routes>
        <Route path="/:qrId?" element={<QrCodeContent />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </>
  );
}

function Connectby() {
  return (
    <ConfigProvider direction="ltr" theme={{ token: { colorPrimary: '#0D9298' } }}>
      <Router>
        <App />
      </Router>
    </ConfigProvider>
  );
}

export default Connectby;